import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import {
  Affix,
  Avatar,
  Button,
  Card,
  Carousel,
  Col,
  Divider,
  Drawer,
  Empty,
  Form,
  Input,
  Layout,
  List,
  Menu,
  Popconfirm,
  Popover,
  Radio,
  Row,
  Select,
  Slider,
  Table,
  Tooltip,
  Typography,
  Collapse,
  Modal,
} from "ant-design-vue";

createApp(App)
  .use(router)
  .use(createPinia())
  .use(Button)
  .use(Layout)
  .use(Drawer)
  .use(Radio)
  .use(Menu)
  .use(List)
  .use(Row)
  .use(Col)
  .use(Form)
  .use(Input)
  .use(Select)
  .use(Empty)
  .use(Avatar)
  .use(Card)
  .use(Carousel)
  .use(Popconfirm)
  .use(Popover)
  .use(Tooltip)
  .use(Divider)
  .use(Affix)
  .use(Slider)
  .use(Table)
  .use(Typography)
  .use(Collapse)
  .use(Modal)
  .mount("#app");
